import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { API } from "@/lib/api";
import { Hand, Flame, ChevronRight } from "lucide-react";

function photo(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${API.replace(/\/api$/, "")}${url}`;
}

export default function TopClappedWidget() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/contributor/top-clapped", { params: { limit: 3 } })
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || items.length === 0) return null;

  const hero = items[0];
  const rest = items.slice(1);

  return (
    <section className="mb-8 rounded-2xl bg-gradient-to-br from-rose-50 via-amber-50 to-orange-50 border-2 border-amber-200 shadow-sm overflow-hidden" data-testid="top-clapped-widget">
      <div className="p-5 md:p-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center shadow-md">
            <Flame className="w-5 h-5"/>
          </div>
          <div className="flex-1">
            <div className="uppercase tracking-[0.22em] text-[9px] text-orange-700 font-black">Most Clapped · जनता की पसंद</div>
            <h3 className="font-devnagri-heading text-lg md:text-xl font-black text-[#0F172A] leading-tight">आज की सबसे ज़्यादा ताली पाई ख़बर</h3>
          </div>
          <Link to="/contribute" className="hidden sm:inline-flex items-center gap-1 text-xs font-bold text-[#EA580C] hover:underline" data-testid="tc-more">
            सभी देखें <ChevronRight className="w-3.5 h-3.5"/>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Hero */}
          <Link to="/contribute" className="md:col-span-2 relative bg-white rounded-xl border border-amber-200 overflow-hidden hover:shadow-lg transition group flex flex-col md:flex-row" data-testid="tc-hero">
            {hero.photo_url ? (
              <div className="md:w-48 shrink-0 aspect-video md:aspect-auto bg-slate-100">
                <img src={photo(hero.photo_url)} alt="" className="w-full h-full object-cover"/>
              </div>
            ) : null}
            <div className="p-4 flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center font-black text-xs shrink-0">{hero.name?.[0] || "?"}</div>
                <div className="min-w-0 flex-1">
                  <div className="font-bold text-sm text-[#0F172A] truncate">{hero.name}</div>
                  <div className="text-[10px] text-slate-500 truncate">{hero.city ? `📍 ${hero.city}` : "—"}</div>
                </div>
                <div className="inline-flex items-center gap-1 shrink-0 bg-gradient-to-r from-amber-400 to-orange-500 text-white text-xs font-black px-2.5 py-1 rounded-full shadow">
                  <Hand className="w-3.5 h-3.5 fill-current"/> {hero.claps}
                </div>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed line-clamp-3">{hero.text}</p>
              {hero.claps >= 100 && <div className="mt-2 inline-block bg-red-500 text-white text-[9px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full">🔥 वायरल</div>}
            </div>
          </Link>

          {/* Rest */}
          <div className="grid grid-cols-1 gap-3">
            {rest.map((c, i) => (
              <Link key={c.id} to="/contribute" className="bg-white rounded-xl border border-amber-100 p-3 hover:shadow-md transition flex items-center gap-3" data-testid={`tc-item-${i}`}>
                <div className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center font-black text-xs ${
                  i === 0 ? "bg-slate-300 text-white" : "bg-orange-400 text-white"
                }`}>{i === 0 ? "🥈" : "🥉"}</div>
                <div className="min-w-0 flex-1">
                  <div className="font-bold text-xs text-[#0F172A] truncate">{c.name}</div>
                  <div className="text-[10px] text-slate-500 line-clamp-1">{c.text}</div>
                </div>
                <div className="inline-flex items-center gap-1 shrink-0 bg-amber-100 text-amber-700 text-[10px] font-black px-2 py-0.5 rounded-full">
                  <Hand className="w-3 h-3 fill-current"/> {c.claps}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
